export default {
    label_task:{
        en:"Crop Types",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Type",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Type",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Type",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
}